import { useState, useEffect } from "react"
import {
  SubmitBtn,
  ActionSection,
  ScrollableContent,
  SideCancelBtn,
  ModalHeader,
} from "../Styles/InputStyles"
import { toast } from "react-toastify"
import { MdClose } from "react-icons/md"
import tw from "tailwind-styled-components"
import "react-dropdown/style.css"

const FilterModal = ({
  selectedData,
  onApplyFilter,
  handleClose
}) => {
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [height, setHeight] = useState(window.innerHeight)

  const filterGroups = [
    {
      title: "Landlord/Lease Details",
      options: [
        { value: "LNV", label: "Pending" },
        { value: "LBV", label: "Basic" },
        { value: "LV", label: "Completed" },
      ],
    },
    {
      title: "Occupancy Level",
      options: [
        { value: "FO", label: "Full Occupied" },
        { value: "NFO", label: "Vacancies Available" },
      ],
    },
    {
      title: "Profitability",
      options: [
        { value: "LMP", label: "Loss Making" },
        { value: "PMP", label: "Profit Making" },
      ],
      notes: "Insights will represent the current month’s performance."
    }
  ];

  const handleApplyFilter = () => {
    if (selectedFilter)
      onApplyFilter(selectedFilter.value, selectedFilter.label, selectedFilter.type);
    else
      toast.error("Please select at least one filter before applying.");
  };

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight)
    }
    window.addEventListener("resize", handleResize)
    handleResize()
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const handleFilterSelect = (filterType, option) => {
    // If clicking the already selected filter, deselect it
    if (selectedFilter?.value === option.value) {
      setSelectedFilter(null);
    } else {
      // Otherwise set the new filter (replacing any previous selection)
      setSelectedFilter({
        type: filterType,
        value: option.value,
        label: option.label
      });
    }
  };

  return (
    <Container style={{ height: `${height}px`, overflow: "auto", WebkitOverflowScrolling: "touch" }}>
      <ModalHeader>
        <h1 className="text-lg font-medium text-white">Filters</h1>
        <button onClick={handleClose}>
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>
      <div className="custom-scrollbar flex h-full flex-col justify-between px-4">
        <ScrollableContent className="max-h-[calc(100vh-140px)] overflow-y-auto mt-4">
          {filterGroups.map((group) => (
            <FilterGroup key={group.title}>
              <FilterTitle>{group.title}</FilterTitle>
              <FilterOptions>
                {group.options.map((option) => {
                  const isActive = selectedFilter?.value === option.value;
                  return (
                    <FilterOption
                      key={option.value}
                      active={isActive}
                      onClick={() => handleFilterSelect(group.title, option)}
                    >
                      {option.label}
                    </FilterOption>
                  );
                })}
              </FilterOptions>
              {
                group.notes &&
                <FilterNotes> {group.notes} </FilterNotes>
              }
            </FilterGroup>
          ))}
        </ScrollableContent>
        <ActionSection>
          <SideCancelBtn type="button" onClick={handleClose}>
            Cancel
          </SideCancelBtn>
          <SubmitBtn type="submit" onClick={handleApplyFilter}>
            Apply Filter
          </SubmitBtn>
        </ActionSection>

      </div>
    </Container>
  )
}

const Container = tw.div`bg-white w-full h-full flex flex-col relative`
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`
const FilterGroup = tw.div`mb-4 p-4 bg-gray-50`;
const FilterTitle = tw.h3`text-md font-medium text-gray-800 mb-2`;
const FilterNotes = tw.h3`text-xs font-sm text-gray-500 mt-2`;
const FilterOptions = tw.div`flex flex-wrap gap-2 mt-2`;
const FilterOption = tw.button`px-3 py-1.5 text-sm rounded-full border transition-colors duration-200 ${({ active }) => active ? "border-primary-color text-primary-color" : "bg-white border-gray-300 text-gray-700 hover:border-gray-400"}`;

export default FilterModal